/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Knowit
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const H5P = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 20 20" {...props}>
    <path d="M19.26 6.33q-.73-.71-2.22-.71h-3.32v1.87H9.73L9.4 8.83a6 6 0 0 1 .93-.32q.4-.07.8-.05 1.32 0 2.14.8c.82.8.83 1.21.83 2.02q0 .86-.43 1.65a3 3 0 0 1-1.2 1.2 3 3 0 0 1-.62.25h3.38v-3.2h1.51q1.65 0 2.46-.76.8-.75.8-2.09 0-1.3-.74-2M17.03 9.1q-.32.27-1.11.27h-.69V7.43h.8q.76 0 1.04.28a1 1 0 0 1 .28.7 1 1 0 0 1-.32.69" />
    <path d="M10.25 10.05c-.48 0-.9.28-1.1.67l-2.38-.33 1.08-4.77H5.68v3.75H2.66V5.62H0v8.76h2.66v-3.2h3.02v3.2h3.28a3 3 0 0 1-1.04-.49 3 3 0 0 1-.71-.74 4 4 0 0 1-.44-1l2.4-.34c.2.4.6.67 1.07.67a1.22 1.22 0 0 0 0-2.43" />
  </Icon>
);
